module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_06_6DB79_1SB_GSK.cbfa7ba4.png";